import HorizontalDivider from '@/global/components/Divider/HorizontalDivider'
import Grid from '@/global/components/ui/Grid'
import { Label } from '@/global/components/ui/label'
import { Button } from 'global/components/Button'
import { hasPermission } from 'hooks/useBackendMenu'

export function Seguranca() {
    return hasPermission(['update', 'Funcionários'], () => (
        <section id="seguranca">
            <HorizontalDivider className="mb-4 mt-6">
                Segurança
            </HorizontalDivider>
            <Grid container rowSpacing={8}>
                <Grid item xs={12}>
                    <Label className="text-sm block text-center">
                        A senha padrão atribuída ao funcionário é o seu CPF.
                        Caso necessário, é possível modificá-la. <br />O
                        funcionário também possui a opção de alterar a própria
                        senha por meio do seu perfil.
                    </Label>
                </Grid>
                <Grid item xs={12}>
                    <Button
                        href="alterar-senha"
                        color="warning"
                        className="max-w-md mx-auto"
                    >
                        Alterar senha do funcionário
                    </Button>
                </Grid>
            </Grid>
        </section>
    ))
}
